// Renders a light-markup field (see utils/lightMarkup.js) as article prose —
// used for expert articles hosted from Airtable. The FAQ page doesn't use
// this; it maps the same markup onto ContentPage's existing answer renderer.

import { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { COLORS, HEADING, TYPE } from 'styles/theme';
import { parseLightMarkup } from 'utils/lightMarkup';

const LINK = { color: COLORS.dark, textDecoration: 'underline', fontWeight: 600 };

function Inline({ value }) {
  if (typeof value === 'string') return value;
  return value.map((seg, i) => {
    if (typeof seg === 'string') return <Fragment key={i}>{seg}</Fragment>;
    if (seg.bold) return <strong key={i}>{seg.bold}</strong>;
    if (seg.to) return <Link key={i} to={seg.to} style={LINK}>{seg.label}</Link>;
    return <a key={i} href={seg.href} target="_blank" rel="noreferrer" style={LINK}>{seg.label}</a>;
  });
}

export default function LightMarkup({ text }) {
  const body = { fontSize: TYPE.body, lineHeight: 1.85, color: COLORS.text };
  return parseLightMarkup(text).map((b, i) => {
    if (b.type === 'h') {
      return <h2 key={i} style={{ ...HEADING, fontSize: TYPE.subHeading, margin: '34px 0 12px', color: COLORS.dark }}><Inline value={b.text} /></h2>;
    }
    if (b.type === 'list') {
      const Tag = b.ordered ? 'ol' : 'ul';
      return (
        <Tag key={i} style={{ margin: '0 0 18px', paddingLeft: '24px' }}>
          {b.items.map((item, j) => <li key={j} style={{ ...body, marginBottom: '6px' }}><Inline value={item} /></li>)}
        </Tag>
      );
    }
    return <p key={i} style={{ ...body, margin: '0 0 18px' }}><Inline value={b.text} /></p>;
  });
}
